/* eslint-disable angular/timeout-service */
import { BaseController } from '~/utils/base-controller';
// import { scopeCompletionSource } from '@codemirror/lang-javascript';
import {
	Keymaps, LanguageExtensions, Plugins, ThemeExtensions,
} from '@knitiv/code-editor';
import { Compartment } from '@codemirror/state';
import { scopeCompletionSource } from '@codemirror/lang-javascript';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevMfController extends BaseController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {Knitiv.Angular.Timeout} $timeout
	 * @param {Knitiv.Angular.Interval} $interval
	 */
	constructor($injector, $timeout, $interval) {
		super($injector);

		this.code = `console.log('Hello world')
var x = 2`;

		this.$onInit();

		this.languageCompartment = new Compartment();

		this.$timeout = $timeout;
		this.$interval = $interval;
	}

	onEditorReady() {
		// eslint-disable-next-line angular/interval-service
		this.$interval(() => {
			this.code += '.';
		}, 10_000);
	}

	onEditorSetup() {
		return [
			ThemeExtensions.oneLight,
			this.languageCompartment.of(LanguageExtensions.javascript({ typescript: true })),
			LanguageExtensions.javascriptLanguage.data.of({ autocomplete: scopeCompletionSource(globalThis) }),

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
		];
	}

	async $onInit() {
		//
	}
}
